import { LinearFilter, Material, MeshBasicMaterial, NearestFilter, RGBAFormat, WebGLRenderTarget } from "three";
import { CAMERA_RENDER_HEIGHT, CAMERA_RENDER_WIDTH } from "./CameraViewSystem";
import { MeshRenderable } from "../mesh/MeshRenderable";
import { FacetRenderer, isRenderableType, Renderable, RenderableUpdateTriggerState } from "../renderable/Renderable";
export class CameraRecorderViewRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.renderTarget = new WebGLRenderTarget(CAMERA_RENDER_WIDTH, CAMERA_RENDER_HEIGHT, {
            format: RGBAFormat,
            minFilter: LinearFilter,
            magFilter: NearestFilter
            // encoding: GammaEncoding
            // depthBuffer: false,
            // stencilBuffer: false
        });
        this.material = new MeshBasicMaterial({
            map: this.renderTarget.texture
        });
        this.disableRender = false;
        this.savedMaterials = new Map();
    }
    destroy() {
        this.applySavedMaterial();
        this.savedMaterials.clear();
        this.owner.renderer.cameraViewSystem.removeView(this);
        // this.texture.dispose();
        this.material.dispose();
        this.renderTarget.dispose();
    }
    setVisible(visible) {
        this.disableRender = !visible;
    }
    onInit(facet) {
        this.facet = facet;
        this.applyTextureToRenderable();
        this.owner.renderer.cameraViewSystem.addView(this);
    }
    updateFacet(_facet) { }
    updateTransform() { }
    checkFrustum(frustum) {
        const renderable = this.owner.renderable;
        if (renderable === undefined)
            return false;
        if (!isRenderableType(MeshRenderable, renderable))
            return false;
        if (!renderable.meshInstance.isLoaded)
            return false;
        if (renderable.meshInstance.group === undefined)
            return false;
        return frustum.intersectsObject(renderable.meshInstance.group);
    }
    onOtherRenderableChanged(state, renderable) {
        switch (state) {
            case RenderableUpdateTriggerState.Changed:
                if (renderable instanceof Renderable) {
                    this.applyTextureToRenderable();
                }
                break;
            case RenderableUpdateTriggerState.Destroyed:
                break;
        }
    }
    applyTextureToRenderable() {
        const renderable = this.owner.renderable;
        if (renderable === undefined)
            return;
        if (isRenderableType(MeshRenderable, renderable)) {
            this.applyTextureToMesh(renderable);
        }
    }
    applyTextureToMesh(renderable) {
        if (this.facet === undefined)
            return;
        if (!renderable.meshInstance.isLoaded)
            return;
        renderable.meshInstance.traverseMaterial(Material, (_mat, mesh) => {
            if (!Array.isArray(mesh.material) && mesh.material !== this.material)
                this.savedMaterials.set(mesh.uuid, mesh.material);
            mesh.material = this.material;
        });
    }
    applySavedMaterial() {
        if (this.owner.renderable === undefined)
            return;
        if (!isRenderableType(MeshRenderable, this.owner.renderable))
            return;
        if (!this.owner.renderable.meshInstance.isLoaded)
            return;
        this.owner.renderable.meshInstance.traverseMaterial(Material, (_mat, mesh) => {
            const mat = this.savedMaterials.get(mesh.uuid);
            if (mat === undefined)
                return;
            mesh.material = mat;
        });
    }
}
